import React from 'react';
import { Link } from 'react-router-dom';
interface FooterProps {
  onBuyerContactOpen?: () => void;
  onOwnerContactOpen?: () => void;
}
export function Footer({
  onBuyerContactOpen,
  onOwnerContactOpen
}: FooterProps) {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0a0a0a] border-t border-white/[0.06]" data-id="element-73">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-id="element-74">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-75">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-76">
            <Link to="/" className="inline-block mb-6" data-id="element-77">
              <img src="https://cdn.magicpatterns.com/uploads/vdgv36ytuJeDtCVoSnd1Nw/DF_logo_.png" alt="Deal Flow" className="h-10 w-auto" data-id="element-78" />
            </Link>
            <p className="text-white/35 max-w-sm leading-relaxed text-sm font-light" data-id="element-79">
              Proprietary deal origination for serious buyers. Confidential
              optionality for business owners. Off-market conversations that
              create real value.
            </p>
          </div>

          {/* Navigate */}
          <div data-id="element-80">
            <h4 className="text-[10px] font-semibold text-white/40 uppercase tracking-[0.2em] mb-5" data-id="element-81">
              Navigate
            </h4>
            <ul className="space-y-3" data-id="element-82">
              <li data-id="element-83">
                <Link to="/" className="text-white/40 hover:text-deal-green transition-colors text-sm" data-id="element-84">
                  Home
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/buyers" className="text-white/40 hover:text-deal-green transition-colors text-sm" data-id="element-86">
                  Buyers
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/owners" className="text-white/40 hover:text-deal-green transition-colors text-sm" data-id="element-88">
                  Owners
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/our-team" className="text-white/40 hover:text-deal-green transition-colors text-sm" data-id="element-90">
                  Our Team
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-91">
            <h4 className="text-[10px] font-semibold text-white/40 uppercase tracking-[0.2em] mb-5" data-id="element-92">
              Resources
            </h4>
            <ul className="space-y-3" data-id="element-93">
              <li data-id="element-94">
                <button onClick={onBuyerContactOpen} className="text-white/40 hover:text-deal-green transition-colors text-sm text-left" data-id="element-95">
                  Start a Pilot
                </button>
              </li>
              <li data-id="element-96">
                <button onClick={onOwnerContactOpen} className="text-white/40 hover:text-deal-green transition-colors text-sm text-left" data-id="element-97">
                  Explore Options
                </button>
              </li>
              <li data-id="element-98">
                <Link to="/sample-deal-brief" className="text-white/40 hover:text-deal-green transition-colors text-sm" data-id="element-99">
                  Sample Deal Brief
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-100">
            <h4 className="text-[10px] font-semibold text-white/40 uppercase tracking-[0.2em] mb-5" data-id="element-101">
              Get in Touch
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-102">
              <li data-id="element-103">
                <a href="mailto:dj@getdealflow.ai" className="text-white/40 hover:text-deal-green transition-colors" data-id="element-104">
                  dj@getdealflow.ai
                </a>
              </li>
              <li className="text-white/30" data-id="element-105">Orlando, FL</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/[0.06]" data-id="element-106">
          <p className="text-white/20 text-xs mb-4 max-w-2xl leading-relaxed" data-id="element-107">
            Deal Flow Advisory is not a registered broker-dealer. All
            transactions are conducted in compliance with applicable securities
            laws.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-108">
            <p className="text-white/25 text-xs" data-id="element-109">
              © {currentYear} Deal Flow Advisory. All rights reserved.
            </p>
            <div className="flex gap-6 text-xs" data-id="element-110">
              <a href="#" className="text-white/25 hover:text-deal-green transition-colors" data-id="element-111">
                Privacy Policy
              </a>
              <a href="#" className="text-white/25 hover:text-deal-green transition-colors" data-id="element-112">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}